import { css } from '@emotion/react';

const MAX_WIDTH = 800;

export const commsModalCommonStyles = css`
  justify-self: center;
  max-width: ${MAX_WIDTH}px;
`;
